export default "__VITE_ASSET__qC75R0ac__"